import React, { useState } from 'react';
import medicineData from '../../Datas/DrugsData';
import './MedicineList.css';

const MedicineList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterSeason, setFilterSeason] = useState('All');
  const [filteredMedicines, setFilteredMedicines] = useState(medicineData);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [diseaseModalOpen, setDiseaseModalOpen] = useState(false); 
  const [selectedDiseases, setSelectedDiseases] = useState([]);
  const [activeSeason, setActiveSeason] = useState('All'); 

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    filterData(query, filterSeason, selectedDiseases);
  };

  const handleSeasonFilter = (season) => {
    setFilterSeason(season);
    setActiveSeason(season); 
    filterData(searchQuery, season, selectedDiseases);
  };

  const openDiseaseModal = () => {
    setDiseaseModalOpen(true);
  };

  const closeDiseaseModal = () => {
    setDiseaseModalOpen(false);
  };

  const handleDiseaseSelect = (disease) => {
    setSelectedDiseases((prevDiseases) => [...prevDiseases, disease]); 
    setDiseaseModalOpen(false);
    filterData(searchQuery, filterSeason, [...selectedDiseases, disease]);
  };

  const handleRemoveDiseaseTag = (disease) => {
    setSelectedDiseases((prevDiseases) => prevDiseases.filter((d) => d !== disease));
    filterData(searchQuery, filterSeason, selectedDiseases.filter((d) => d !== disease));
  };

  const filterData = (query, season, diseases) => {
    const filtered = medicineData.filter((medicine) => {
      const matchesSearch =
        medicine.name.toLowerCase().includes(query.toLowerCase()) ||
        medicine.company.toLowerCase().includes(query.toLowerCase());
      const matchesSeason =
        season === 'All' || medicine.seasonalUse === season;
      const matchesDisease =
        diseases.length === 0 ||
        diseases.some((disease) =>
          medicine.diseaseTypes.some((type) =>
            type.toLowerCase().includes(disease.toLowerCase())
          )
        );

      return matchesSearch && matchesSeason && matchesDisease;
    });
    setFilteredMedicines(filtered);
  };

  const openModal = (medicine) => {
    setSelectedMedicine(medicine);
  };

  const closeModal = () => {
    setSelectedMedicine(null);
  };

  return (
    <div className="medicine-list-container">
      <div className="filters">
        <input
          type="text"
          placeholder="Search Medicines..."
          value={searchQuery}
          onChange={handleSearch}
          className="search-bar-drugs"
        />
        <div className="season-filter">
          <button 
            onClick={openDiseaseModal} 
            className="custom-disease-btn"
          >
            Custom Disease
          </button>
          <button
            onClick={() => handleSeasonFilter('All')}
            className={activeSeason === 'All' ? 'active' : ''}
          >
            All Seasons
          </button>
          <button
            onClick={() => handleSeasonFilter('Winter')}
            className={activeSeason === 'Winter' ? 'active' : ''}
          >
            Winter
          </button>
          <button
            onClick={() => handleSeasonFilter('Summer')}
            className={activeSeason === 'Summer' ? 'active' : ''}
          >
            Summer
          </button>
          <button
            onClick={() => handleSeasonFilter('All year round')}
            className={activeSeason === 'All year round' ? 'active' : ''}
          >
            All Year Round
          </button>
        </div>
      </div>

      <div className="tags-container">
        <div className="selected-diseases">
          {selectedDiseases.map((disease, index) => (
            <span key={index} className="disease-tag">
              {disease}
              <button
                onClick={() => handleRemoveDiseaseTag(disease)}
                className="remove-tag-btn"
              >
                &#10005;
              </button>
            </span>
          ))}
        </div>
      </div>

      <div className="medicine-cards">
        {filteredMedicines.length === 0 ? (
          <p>No medicines found</p>
        ) : (
          filteredMedicines.map((medicine) => {
            const seasonalClass = medicine.seasonalUse.toLowerCase().replace(' ', '-');
            return (
              <div key={medicine.id} className={`medicine-card ${seasonalClass}`}>
                <h3>{medicine.name}</h3>
                <p><strong>Company:</strong> {medicine.company}</p>
                <p><strong>Price:</strong> ₹{medicine.price}</p>
                <p><strong>Strength:</strong> {medicine.strength}</p>
                <p><strong>Expiry Date:</strong> {medicine.expiryDate}</p>
                <p><strong>Uses:</strong> {medicine.uses.join(', ')}</p>
                <p><strong>Seasonal Use:</strong> {medicine.seasonalUse}</p>
                <button onClick={() => openModal(medicine)} className="details-btn">Details</button>
              </div>
            );
          })
        )}
      </div>

      {selectedMedicine && (
        <div className="medicine-modal-overlay" onClick={closeModal}>
          <div className="medicine-modal" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedMedicine.name}</h2>
            <p><strong>Company:</strong> {selectedMedicine.company}</p>
            <p><strong>Price:</strong> ₹{selectedMedicine.price}</p>
            <p><strong>Strength:</strong> {selectedMedicine.strength}</p>
            <p><strong>Expiry Date:</strong> {selectedMedicine.expiryDate}</p>
            <p><strong>Uses:</strong> {selectedMedicine.uses.join(', ')}</p>
            <p><strong>Precautions:</strong> {selectedMedicine.precautions.join(', ')}</p>
            <p><strong>Conditions:</strong> {selectedMedicine.conditions.join(', ')}</p>
            <p><strong>Dosage:</strong> {selectedMedicine.dosage}</p>
            <p><strong>Seasonal Use:</strong> {selectedMedicine.seasonalUse}</p>
            <p><strong>Tags:</strong> {selectedMedicine.tags.join(', ')}</p>
            <p><strong>Links:</strong></p>
            <ul>
              {selectedMedicine.links.map((link, index) => (
                <li key={index}><a href={link.url} target="_blank" rel="noopener noreferrer">{link.name}</a></li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {diseaseModalOpen && (
        <div className="medicine-modal-overlay" onClick={closeDiseaseModal}>
          <div className="medicine-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Select a Disease</h2>
            <ul>
              {['Pain', 'Fever', 'Headache', 'Arthritis', 'Bacterial infections', 'Diabetes', 'Allergic rhinitis', 'Depression', 'Anxiety'].map((disease, index) => (
                <li key={index} onClick={() => handleDiseaseSelect(disease)} className="disease-option">
                  {disease}
                </li>
              ))}
            </ul>
            <button onClick={closeDiseaseModal} className="close-modal-btn-disease">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MedicineList;
